import React from "react";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import {
  spfOne,
  spfTwo,
  spfThree,
  spfFour,
} from "../../../assets/images/index";

const SpecialOffers = () => {
  return (
    <div className="w-full pb-20">
      <Heading heading="Special Offers" />
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 xl:grid-cols-4 gap-10">
        <Product
          _id="1101"
          img={spfOne}
          productName="Old Delhi Tour"
          price="inquiry"
          color="Blank and White"
          badge={true}
          des="Old Delhi Tour is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels."
        />
        <Product
          _id="1102"
          img={spfTwo}
          productName="Old Delhi Tour"
          price="inquiry"
          color="Gray"
          badge={true}
          des="Old Delhi Tour is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels."
        />
        <Product
          _id="1103"
          img={spfThree}
          productName="Old Delhi Tour"
          price="inquiry"
          color="Mixed"
          badge={true}
          des="Old Delhi Tour is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels."
        />
        <Product
          _id="1104"
          img={spfFour}
          productName="Old Delhi Tour"
          price="inquiry"
          color="Black"
          badge={true}
          des="Old Delhi Tour is a historic district in Delhi, India, known for its rich cultural heritage and architectural marvels."
        />
      </div>
    </div>
  );
};

export default SpecialOffers;
